import { render, staticRenderFns } from "./forming_method.vue?vue&type=template&id=30eec7eb&scoped=true"
import script from "./forming_method.vue?vue&type=script&lang=js"
export * from "./forming_method.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30eec7eb",
  null
  
)

export default component.exports